import Images from "../utils/Images";

export const rootOptions = [
  {
    key: "insurance",
    title: "Insurance",
    subtitle: "Your trusted protection partner",
    image: Images.daily_commuter || "/images/daily_commuter.png",
  },
  {
    key: "travel",
    title: "Travel, Tour & Logistics",
    subtitle: "Seamless journeys, stress free logistics",
    image: Images.travel_insurance,
    comingSoon: true,
  },
  {
    key: "tourism",
    title: "Media and Event ",
    subtitle: "Where creativity meet unforgettable experiences",
    image: Images.tourism_card,
    comingSoon: true,
  },
  {
    key: "safety",
    title: "Safety Services",
    subtitle: "Your partner in protection and safety",
    image: Images.safety_card,
    comingSoon: true,
  },
];

export const insuranceOptions = [
  {
    key: "road-trip",
    title: "Tripsecure Insurance",
    link: "/insurance/road-trip",
    subtitle: "Reliable coverage for every journey on the road.",
    image: Images.ts_shield,
  },
  {
    key: "travel",
    title: "Travel Insurance",
    link: "/insurance/travel",
    subtitle: "Reliable protection for your air travels.",
    image: Images.travel_insurance,
  },
  {
    key: "life",
    title: "Life Insurance",
    link: "/insurance/life",
    subtitle: "Secure your loved ones, secure your future",
    image: Images.life_insurance,
  },
  {
    key: "general",
    title: "General Insurance",
    link: "/insurance/general",
    subtitle: "Protection for every part of your life",
    image: Images.general_insurance,
  },
];
